import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import InputErrorMessage from '../../lego/InputErrorMessage';
import InputHint from '../../lego/InputHint';
import InputLabelSubText from '../../lego/InputLabelSubText';
import InputLabelText from '../../lego/InputLabelText';
import InputSuccessMessage from '../../lego/InputSuccessMessage';
import FormElement from '../../layouts/FormElement';
import TagInputField from '../../lego/TagInputField';
const TagInput = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { id, label, isLabelHidden, noBottomSpacing, className, subLabel, details, validationResult, isRequired } = _param, rest = _object_without_properties(_param, [
        "id",
        "label",
        "isLabelHidden",
        "noBottomSpacing",
        "className",
        "subLabel",
        "details",
        "validationResult",
        "isRequired"
    ]);
    let wrappedDetails = null;
    const errorMessageId = `${id}-error`;
    const hintId = `${id}-hint`;
    switch(validationResult){
        case 'success':
            wrappedDetails = /*#__PURE__*/ React.createElement(InputSuccessMessage, null, details);
            break;
        case 'error':
            wrappedDetails = /*#__PURE__*/ React.createElement(InputErrorMessage, {
                id: errorMessageId
            }, details);
            break;
        default:
            wrappedDetails = /*#__PURE__*/ React.createElement(InputHint, {
                id: hintId
            }, details);
    }
    return /*#__PURE__*/ React.createElement(FormElement, {
        className: className,
        inputId: id,
        label: /*#__PURE__*/ React.createElement(InputLabelText, {
            isRequired: isRequired
        }, label),
        isLabelHidden: isLabelHidden,
        subLabel: subLabel && /*#__PURE__*/ React.createElement(InputLabelSubText, null, subLabel),
        details: details && wrappedDetails,
        noBottomSpacing: noBottomSpacing
    }, /*#__PURE__*/ React.createElement(TagInputField, _object_spread({
        id: id,
        ref: ref,
        isRequired: isRequired,
        validationResult: validationResult,
        "aria-errormessage": errorMessageId,
        "aria-describedby": validationResult === undefined && details ? hintId : undefined,
        autoComplete: "off"
    }, rest)));
});
TagInput.displayName = 'TagInput';
export default TagInput;
